module.exports = __webpack_public_path__ + "static/07_global_temp_record-ca7573c14c66f175a86c2f5af7ec06e5.gif";